<template>
  <editor :id="id" default-tab="device" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import Device from './editor/Device'
import DeviceLog from './editor/DeviceLog'
import Subdevices from './editor/Subdevices'

export default {
  props: ['id'],
  components: {
    Editor
  },
  data () {
    return {
      tabs: [
        {title: "Device", name: "device", component: Device},
        {title: "Log", name: "log", component: DeviceLog},
        {title: "Tree", name: "subdevices", component: Subdevices}
      ]
    }
  }
}
</script>
